/**
 * Copyright (c) 2025 eBUCIS, LLC. All rights reserved.
 *
 * Authentication Page Marketing Content
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * distribution, or modification is strictly prohibited.
 */

import { branding } from '../config/branding'
import { useBranding } from '../stores/brandingStore'

// Static default (non-React callers / first paint). Whitelabel-aware content
// is provided by useAuthContent() below.
export const authContent = {
  branding: {
    logo: branding.name.toUpperCase(),
    tagline: branding.tagline,
    description: branding.description
  },

  valuePropositions: branding.valuePropositions
}

/**
 * Whitelabel-aware auth marketing content. Mirrors the `authContent` shape but
 * sourced from the resolved organization branding.
 */
export function useAuthContent() {
  const b = useBranding()
  return {
    branding: {
      logo: (b.name || '').toUpperCase(),
      tagline: b.tagline,
      description: b.description
    },
    valuePropositions: b.valuePropositions
  }
}

export default authContent
